import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { submitFeedback } from '../services/firestoreService';
import '../styles/feedback.css';

const LABELS = ['', 'Poor', 'Fair', 'Good', 'Great', 'Excellent'];

export const FeedbackForm = ({ type = 'daily', onDone, compact = false }) => {
  const { currentUser } = useAuth();
  const [rating, setRating]   = useState(0);
  const [hovered, setHovered] = useState(0);
  const [note, setNote]       = useState('');
  const [status, setStatus]   = useState('idle'); // idle | saving | done | error

  const handleSubmit = async () => {
    if (!rating) return;
    setStatus('saving');
    const res = await submitFeedback(
      currentUser?.uid || 'anonymous',
      currentUser?.email || '',
      rating,
      note,
      type,
    );
    setStatus(res.success ? 'done' : 'error');
    if (res.success && onDone) setTimeout(onDone, 1400);
  };

  if (status === 'done') {
    return (
      <div className="fb-done">
        <span className="fb-done-icon">✓</span>
        <p className="fb-done-text">Thanks for your feedback!</p>
      </div>
    );
  }

  const display = hovered || rating;

  return (
    <div className={`fb-form${compact ? ' fb-form--compact' : ''}`}>
      <div className="fb-stars">
        {[1, 2, 3, 4, 5].map(n => (
          <button
            key={n}
            type="button"
            className={`fb-star${n <= display ? ' fb-star--on' : ''}`}
            onMouseEnter={() => setHovered(n)}
            onMouseLeave={() => setHovered(0)}
            onClick={() => setRating(n)}
            aria-label={`${n} star${n > 1 ? 's' : ''}`}
          >
            ★
          </button>
        ))}
      </div>
      {display > 0 && (
        <p className="fb-star-label">{LABELS[display]}</p>
      )}
      <textarea
        className="fb-note"
        placeholder="Any issues or comments? (optional)"
        value={note}
        onChange={e => setNote(e.target.value)}
        rows={compact ? 3 : 4}
        maxLength={1000}
      />
      {status === 'error' && (
        <p className="fb-error">Something went wrong — please try again.</p>
      )}
      <button
        className="fb-submit"
        onClick={handleSubmit}
        disabled={!rating || status === 'saving'}
      >
        {status === 'saving' ? 'Sending…' : 'Submit Feedback'}
      </button>
    </div>
  );
};

export const FeedbackModal = ({ onClose }) => (
  <div className="fb-overlay" onClick={onClose}>
    <div className="fb-modal" onClick={e => e.stopPropagation()}>
      <button className="fb-modal-close" onClick={onClose} aria-label="Dismiss">×</button>
      <p className="fb-modal-eyebrow">Daily Check-in</p>
      <h2 className="fb-modal-title">How's Stimuli Central working for you?</h2>
      <p className="fb-modal-sub">Tap a star, leave a note if anything needs fixing.</p>
      <FeedbackForm type="daily" onDone={onClose} />
      <button className="fb-skip" onClick={onClose}>Skip for today</button>
    </div>
  </div>
);
